import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import { AnimatePresence, motion } from 'framer-motion'
import { useEase } from './motion'

export const AudioPlayer = (props) => {
   const [playing, setPlaying] = useState(false)
	const togglePlaying = () => setPlaying( (currentState) => (!currentState ) )

	const playerVar = {
		out: {
			opacity: 0,
		},
		in: {
			opacity: 1,
			transition: {
				delay: 2,
				duration: 0.5,
				ease: useEase('easeOutExpo')
			}
		}
	}

   return (
		<motion.div
			className="audioPlayer"
			variants={playerVar}
			initial="out"
			animate={props.coverLoaded ? "in" : "out"}
			exit="out"
		>
			{props.audio &&
				<>
					<ListenButton
						theme="light"
						playing={playing}
						onClick={togglePlaying}
					/>
					<ReactPlayer
						url={props.audio}
						playing={playing}
						wrapper="audioPlayer-player"
						height={0}
						width={0}
						onEnded={togglePlaying}
						config={{
							file: {
								forceAudio: true,
							},
						}}
					/>
				</>
			}
		</motion.div>
   )
}

export const ListenButton = (props) => {

   const offVariants = {
		paused: {
			opacity: 1,
			transition: {
				duration: 0.5,
			},
		},
		playing: {
			opacity: 0,
			transition: {
				duration: 0.5,
			},
		},
   }

   const onVariants = {
		paused: {
			opacity: 0,
			transition: {
				duration: 0.5,
			},
		},
		playing: {
			opacity: 1,
			transition: {
				duration: 0.5,
			},
		},
   }

   const listenTheme = props.theme ? props.theme : ""
   const listenClasses = `ui-listen ui-theme-${listenTheme}`

   return (
		<button onClick={props.onClick} className={listenClasses}>
			<AnimatePresence exitBeforeEnter>
				{!props.playing ? (
					<motion.svg
						xmlns="http://www.w3.org/2000/svg"
						width="80"
						height="80"
						viewBox="0 0 80 80"
						initial={{ opacity: 0, transition: { duration: 1 } }}
						animate={{ opacity: 1, transition: { duration: 1 } }}
						exit={{ opacity: 0, transition: { duration: 1 } }}
					>
						<g id="listen_btn" transform="translate(-257 -419)">
							<g id="cyan">
								<g
									id="Ellipse_22"
									transform="translate(257 419)"
									fill="none"
									stroke="aqua"
									strokeWidth="1"
								>
									<circle
										cx="40"
										cy="40"
										r="40"
										stroke="none"
									/>
									<circle
										cx="40"
										cy="40"
										r="39.5"
										fill="none"
									/>
								</g>
								<path
									id="Path_62"
									d="M4.955,0,9.911,8.259H0Z"
									transform="translate(302.629 454.156) rotate(90)"
									fill="aqua"
								/>
							</g>
							<g id="red">
								<g
									id="Ellipse_22-2"
									transform="translate(257 419)"
									fill="none"
									stroke="red"
									strokeWidth="1"
								>
									<circle
										cx="40"
										cy="40"
										r="40"
										stroke="none"
									/>
									<circle
										cx="40"
										cy="40"
										r="39.5"
										fill="none"
									/>
								</g>
								<path
									id="Path_62-2"
									d="M4.955,0,9.911,8.259H0Z"
									transform="translate(302.629 454.156) rotate(90)"
									fill="red"
								/>
							</g>
							<g id="default">
								<g
									id="Ellipse_22-3"
									transform="translate(257 419)"
									fill="none"
									stroke="currentColor"
									strokeWidth="1"
								>
									<circle
										cx="40"
										cy="40"
										r="40"
										stroke="none"
									/>
									<circle
										cx="40"
										cy="40"
										r="39.5"
										fill="none"
									/>
								</g>
								<path
									id="Path_62-3"
									d="M4.955,0,9.911,8.259H0Z"
									transform="translate(302.629 454.156) rotate(90)"
									fill="currentColor"
								/>
							</g>
						</g>
					</motion.svg>
				) : (
					<motion.svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 99 96.76"
						className="listen_playing"
						initial={{ opacity: 0, transition: { duration: 1 } }}
						animate={{ opacity: 1, transition: { duration: 1 } }}
						exit={{ opacity: 0, transition: { duration: 1 } }}
					>
						<g id="playing">
							<g id="cyan">
								<path
									id="Path_11"
									data-name="Path 11"
									d="M50.5,52.81v-10h3v10Zm-5,0v-10h3v10Z"
									fill="aqua"
								/>
							</g>
							<g id="red">
								<path
									id="Path_11-2"
									data-name="Path 11-2"
									d="M50.5,52.81v-10h3v10Zm-5,0v-10h3v10Z"
									fill="red"
								/>
							</g>
							<g id="white">
								<path
									id="Path_11-3"
									data-name="Path 11-3"
									d="M50.5,52.81v-10h3v10Zm-5,0v-10h3v10Z"
									fill="#fff"
								/>
							</g>
							<g id="red_wave">
								<path
									d="M61.78,2.31v.74c3.6,0,8.23.28,12.11,2.52,5.27,3.06,8.27,9,11.17,14.65.92,1.81,1.87,3.67,2.87,5.41s2.12,3.41,3.22,5.08c3.5,5.3,7.11,10.78,7.11,17.1s-3.61,11.81-7.11,17.11c-1.1,1.66-2.24,3.39-3.22,5.08s-2,3.6-2.87,5.41c-2.9,5.7-5.9,11.59-11.17,14.64-3.88,2.24-8.51,2.53-12.11,2.53-2,0-4.06-.1-6.07-.2s-4.15-.2-6.21-.2-4.17.1-6.21.2-4.09.2-6.08.2c-3.6,0-8.22-.29-12.1-2.53-5.27-3-8.27-8.94-11.17-14.64C13,73.6,12.07,71.73,11.07,70S9,66.58,7.85,64.92C4.35,59.62.73,54.14.73,47.81S4.35,36,7.85,30.71C9,29,10.09,27.32,11.07,25.63S13,22,13.94,20.22c2.9-5.7,5.9-11.59,11.17-14.65,3.88-2.24,8.5-2.52,12.1-2.52,2,0,4.07.1,6.08.2s4.15.2,6.21.2,4.17-.11,6.21-.2,4.08-.2,6.07-.2V2.31m0,0c-4,0-8.21.4-12.28.4s-8.26-.4-12.29-.4c-4.5,0-8.79.5-12.47,2.63C17.57,9.09,14.59,18.08,10.43,25.26,6.41,32.22,0,39.2,0,47.81s6.41,15.6,10.43,22.56c4.16,7.17,7.14,16.16,14.31,20.32,3.68,2.12,8,2.62,12.47,2.62,4,0,8.22-.4,12.29-.4s8.26.4,12.28.4c4.51,0,8.8-.5,12.47-2.62,7.18-4.16,10.16-13.15,14.31-20.32,4-7,10.44-13.94,10.44-22.56S92.59,32.22,88.56,25.26C84.41,18.08,81.43,9.09,74.25,4.94c-3.67-2.13-8-2.63-12.47-2.63Z"
									fill="red"
								/>
							</g>
							<g id="cyan_wave">
								<path
									d="M41.19,0V.73c4.43,0,9,1.45,13.77,3,1.95.62,4,1.27,5.95,1.8s4,1,6,1.4c6.57,1.41,12.78,2.74,17,6.92s5.69,10.78,7,17c.42,2,.86,4,1.38,6s1.17,3.84,1.8,5.73c2,6,4.11,12.25,2.48,18.36S90.09,71.4,85.34,75.62c-1.49,1.33-3,2.7-4.41,4.08s-2.81,3-4.17,4.49C72.49,89,68.08,93.88,62.2,95.47a16.76,16.76,0,0,1-4.39.56c-4.43,0-9-1.45-13.77-3-1.95-.62-4-1.27-5.95-1.8s-4.06-1-6.06-1.4c-6.57-1.41-12.77-2.74-17-6.93s-5.69-10.77-7-17c-.42-2-.86-4-1.39-6s-1.16-3.84-1.8-5.73c-2-6-4.1-12.25-2.48-18.36s6.54-10.48,11.28-14.7c1.49-1.33,3-2.7,4.42-4.08s2.81-3,4.16-4.49C26.5,7.81,30.92,2.88,36.8,1.29A16.7,16.7,0,0,1,41.19.73V0m0,0a17.28,17.28,0,0,0-4.58.58c-8,2.17-13.2,10.09-19.06,16C11.87,22.23,3.88,27.32,1.67,35.65S3.85,52.36,6,60.12c2.16,8,2.73,17.46,8.6,23.32,5.69,5.68,15,6.31,23.35,8.52,6.71,1.79,13.48,4.8,19.91,4.8a17.28,17.28,0,0,0,4.58-.58c8-2.17,13.2-10.09,19.06-16,5.68-5.69,13.67-10.78,15.88-19.11s-2.18-16.72-4.28-24.47c-2.17-8-2.73-17.46-8.6-23.32C78.76,7.64,69.43,7,61.1,4.8,54.39,3,47.62,0,41.19,0Z"
									fill="aqua"
								/>
							</g>
						</g>
					</motion.svg>
				)}
			</AnimatePresence>
			<motion.span
				variants={offVariants}
				initial="paused"
				animate={props.playing ? "playing" : "paused"}
			>
				Listen
			</motion.span>
		</button>
   )
}